import { render } from "./Header-Bosa.vue?vue&type=template&id=54592c22&scoped=true"
import script from "./Header-Bosa.vue?vue&type=script&lang=js"
export * from "./Header-Bosa.vue?vue&type=script&lang=js"

import "./Header-Bosa.vue?vue&type=style&index=0&id=54592c22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54592c22"]])

export default __exports__